import { createContext, useEffect, useState } from 'react';

const defaultVal = {};
export const WorkspaceContext = createContext(defaultVal);
export const WorkspaceProvider = ({ children }) => {
  // 1️⃣ Load initial value from sessionStorage (if exists)
  const [selectedDatasets, setSelectedDatasets] = useState(() => {
    const stored = sessionStorage.getItem('selectedDatasets');
    return stored ? JSON.parse(stored) : [];
  });

  // 2️⃣ Save to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem(
      'selectedDatasets',
      JSON.stringify(selectedDatasets)
    );
  }, [selectedDatasets]);

  return (
    <WorkspaceContext.Provider
      value={{
        selectedDatasets,
        setSelectedDatasets,
      }}
    >
      {children}
    </WorkspaceContext.Provider>
  );
};

export default WorkspaceContext;
